import {Component, OnInit, ViewChild} from '@angular/core';
import {CorePage} from "../../../core/page/core-page/core.page";
import {ActivatedRoute, Router} from "@angular/router";
import {MenuItem} from "primeng/api";
import {
  OnboardingStepDto,
  OnboardingDto,
  FormFieldsDtoForInsurance, FormFieldsDto,
} from "../../types/ob.interfaces";
import {Carousel, CarouselPageEvent} from "primeng/carousel";
import {OnboardingService} from "../../api/onboarding.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {
  FormDto,
  FormFieldDto,
  ScheduleDto,
  ScheduleTypeDto,
  ScheduleTypeInternal
} from "../../../core/interfaces/core.types";
import {Observable} from "rxjs";
import {
  BookingAppointmentDto,
  BookingSlotDto,
  BookingTimePeriodDto
} from "../../../cross/bookings/types/bookings.types";
import {AppMessageService} from "../../../core/service/app-message.service";
import { MessageHelper } from '../../../core/helper/message-helper';
import {FieldAccess} from "../../../rg/types/registration.types";


@Component({
  selector: 'ob-onboarding-page',
  templateUrl: 'onboarding.page.html',
  styleUrls: ['onboarding.page.css']
})
export class OnboardingPage extends CorePage implements OnInit {

  override defaultLabel: string = "onBoarding";

  @ViewChild('myCarousel') myCarousel: Carousel | undefined;

  currentCarouselIndex: number = 0;
  onboardingDto: OnboardingDto | undefined;
  infoSteps: OnboardingStepDto[] = [];
  steps: MenuItem[] | undefined;
  activeStep: number = 1;
  questionerForm: FormGroup | undefined;
  insuranceFieldsList: FormFieldsDtoForInsurance[] | undefined;
  selectedType: ScheduleTypeDto | undefined;
  appointmentId: number | undefined;
  showDescription: boolean = false;

  selectedScheduleType?: ScheduleTypeDto;
  bookingPeriod?: BookingSlotDto | null;

  constructor(
    protected messageService: AppMessageService,
    private fb: FormBuilder,
    protected override route: ActivatedRoute,
    protected router: Router,
    protected onboardingService: OnboardingService,
  ) {
    super(route);
  }

  override ngOnInit() {
    super.ngOnInit();

    this.route.params.subscribe(params => {
      this.activeStep = +params['step'];
    });

    this.initializeSteps();
    this.initComponent();
  }

  refreshComponent() {
    this.initialized = true;
  }

  initializeSteps() {
    this.steps = [
      {id: '1', label: 'Einführung'},
      {id: '2', label: 'Deine Verträge'},
      {id: '3', label: 'Fragebogen'},
      {id: '4', label: 'Termin vereinbaren'},
    ]
  }

  initComponent() {

    this.getOnboardingObservable().subscribe((res: OnboardingDto) => {
      this.onboardingDto = res;
      this.infoSteps = res.infoSteps;
      this.changeInsuranceFromToArray();
      this.refreshComponent();
      this.buildQuestionerFormGroup(res);
    }, error => {
      MessageHelper.showErrorMessage(error.error.data, this.messageService);
    })
  }

  changeInsuranceFromToArray() {
    if (this.onboardingDto) {
      this.insuranceFieldsList = Object.entries(this.onboardingDto.formInsurance.formFields).map(([key, value]) => ({
        key,
        ...value,
      }));
    }
  }


  getOnboardingObservable(): Observable<OnboardingDto> {

    const continueParam = this.route.snapshot.queryParams['continue'];

    if (continueParam || this.activeStep > 1) {
      return this.onboardingService.getOnboardingOnRegistration();
    } else {
      return this.onboardingService.startOnboardingOnRegistration();
    }

  }

  handleStepChange(step: MenuItem) {
    const index = this.steps?.findIndex((item: MenuItem) => item === step);
    if (index != undefined) {
      const nextStep = this.activeStep = index + 1;
      // Navigate to the next step
      this.router.navigate(['/ob/start', nextStep]);

    }
  }

  gotoPreviousStep() {
    let isParamType: boolean = false;

    if (this.activeStep == 4) {
      // this.route.queryParams.subscribe(params => {
      //   if (params['type']) {
      //     isParamType = true;
      //
      //   }
      // })
      this.showDescription = true;
      const params = this.route.snapshot.queryParams;
      if (params['typeId']) {
        isParamType = true;
      }
    }

    if (isParamType) {
      this.router.navigate(['/ob/start', 4]);
    } else {
      const nextStep = this.activeStep - 1;

      // Navigate to the next step
      this.router.navigate(['/ob/start', nextStep]);
    }
  }


  gotoNextStep() {

    this.busy = true;
    if (this.activeStep == 1 && this.currentCarouselIndex < this.infoSteps.length - 1) {
      this.currentCarouselIndex++;
      this.busy = false;
    } else {
      if (this.activeStep == 3) {
        this.updateQuestionnaireOnRegistration();
      }

      if (this.activeStep == 4) {

        if (!this.selectedScheduleType) {
          this.messageService.showErrorMessage("", "Bitte wähle zuerst eine Terminoption aus!");
          this.busy = false;
          return;
        }

        let finalizeOnboarding: Observable<OnboardingDto>;

        if (this.selectedScheduleType.scheduleTypeInternal == ScheduleTypeInternal.bookings) {

          if (!this.bookingPeriod) {
            this.messageService.showErrorMessage("", "Bitte wähle einen freien Termin");
            this.busy = false;
            return;
          }

          finalizeOnboarding = this.onboardingService.finalizeOnboardingOnRegistration(this.selectedScheduleType.id, this.bookingPeriod.id);


        } else {

          finalizeOnboarding = this.onboardingService.finalizeOnboardingOnRegistration(this.selectedScheduleType.id);
        }

        // navigate to home
        finalizeOnboarding.subscribe(value => {
          this.onboardingDto = value;
          this.router.navigate(["/ds/home"]);
          this.busy = false;
        }, error => {
          MessageHelper.showErrorMessage(error.error.data, this.messageService);
          this.busy = false;
        });

      }

      if (this.activeStep == this.steps?.length) {

        return;
      }

      const nextStep = this.activeStep + 1;

      // Navigate to the next step
      this.router.navigate(['/ob/start', nextStep]);
      this.busy = false;
    }

  }

  handleCarouselPageState(event: CarouselPageEvent) {
    if (event.page) {
      this.currentCarouselIndex = event.page;
    }
  }


  updateQuestionnaireOnRegistration() {
    let formFields: FormFieldDto[] = []
    for (let valueKey in this.questionerForm?.value) {
      const value = this.questionerForm?.value[valueKey];
      let field: FormFieldDto = {id: valueKey, value: value};
      formFields.push(field);
    }

    let partialFormDto: Partial<FormDto> = {
      formFields: formFields,
    };

    this.busy = true;

    this.onboardingService.updateQuestionnaireOnRegistration(partialFormDto as FormDto).subscribe(res => {
      this.busy = false;
      this.buildQuestionerFormGroup(res);
    }, error => {
      MessageHelper.showErrorMessage(error.error.data, this.messageService);
      this.busy = false;
    });
  }


  handleSelectedTypeChange(event: ScheduleTypeDto) {

    // we need to pre-finalize the Interaction in case of WhatsApp and Phone as the user will get in touch
    // with us and therefore the Ticket needs to be present.
    if (event.scheduleTypeInternal == ScheduleTypeInternal.whatsapp || event.scheduleTypeInternal == ScheduleTypeInternal.call_us) {
      this.onboardingService.finalizeOnboardingOnRegistration(event.id);
    }

    // no need to show description if we are in sub navigation of step 4

    if (event.scheduleTypeInternal == ScheduleTypeInternal.whatsapp || event.scheduleTypeInternal == ScheduleTypeInternal.call_us || event.scheduleTypeInternal == ScheduleTypeInternal.bookings) {
      this.showDescription = false;
    } else {
      this.showDescription = true;
    }

  }

  handleSelectBookingPeriod(event: BookingSlotDto | null) {
    this.bookingPeriod = event;
  }


  //will move to service or component
  buildQuestionerFormGroup(onboardingDto: OnboardingDto) {
    if (onboardingDto?.formQuestionnaire?.formFields) {
      this.questionerForm = this.buildUiForm(onboardingDto?.formQuestionnaire?.formFields);
    }
  }


  buildUiForm(formFields: FormFieldsDto[]): FormGroup {
    const group: { [key: string]: any } = {};

    formFields.forEach(field => {
      if (field.access == FieldAccess.UPDATE) {
        group[field.id] = [field.value];
      }
    });

    return this.fb.group(group);
  }

}
